import axios from "axios";
import { useEffect, useState } from "react";
import { Alert, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import api from "../../../../utils/api";
import moment from "moment/moment";
import { TfiReload } from "react-icons/tfi";

export const ActionFormModal = ({
  show,
  onHide,
  roomId,
  content,
  prRowId,
  viewPrErrors,
  fetchViewPrErrors,
  setViewPrErrors,
}) => {
  // regenerate function
  const regenerateAuth = async (id) => {
    if (!id) {
      Swal.fire("⚠️ Missing ID", "Form ID is required to regenerate.", "warning");
      return;
    }

    try {
      Swal.fire({
        title: "Please wait...",
        text: "Regenerating authorization...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await api.post("advisor/regenerateTrans", { transId: id });

      // ✅ If API returns success
      if (response?.data?.success || response?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Authorization Regenerated ✅",
          text: response.data.message || "Transaction authorization has been regenerated successfully.",
          timer: 2500,
          showConfirmButton: false,
        });
        fetchViewPrErrors(prRowId); // Refresh the list after regeneration
      } else {
        Swal.fire({
          icon: "info",
          title: "No Changes Detected",
          text: response?.data?.message || "Nothing was regenerated.",
        });
      }
    } catch (error) {
      console.error("❌ Error regenerating auth:", error);

      Swal.fire({
        icon: "error",
        title: "Failed to Regenerate",
        text: error?.response?.data?.message || "Something went wrong while regenerating authorization.",
      });
    }
  };

  return (
    <Modal show={show} size={viewPrErrors && viewPrErrors.length > 0 ? "lg" : ""} onHide={onHide} centered aria-labelledby="fundEditModal">
      <Modal.Header closeButton>
        <Modal.Title className="fs-5 fw-bold">Forms</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {viewPrErrors && viewPrErrors.length > 0 ? (
          <div className="container-fluid">
            {viewPrErrors
              .filter(frm => frm.trans_status !== "Discard") // ✅ exclude "Discard"
              .map((frm, index) => {
                const showRegenerate =
                  (["Failed", "Rejected", "Processing", "Awaiting Auth", "Postponed", "Pending"].includes(
                    frm.trans_status
                  )) &&
                  frm.tran_form_type === "ReInvest";

                return (
                  <div className="d-flex gap-2 flex-column" key={index}>
                    <div className="row align-items-center py-2 border border-gray border-2">
                      {/* Form Name + Client */}
                      <div className="col-md-6 ">
                        <span className="fw-semibold"> {frm.form_name}{" "}</span>
                        <span className="text-muted">
                          {frm?.client_name} ({frm.client_ucc})
                        </span>{' '}
                        <span className="text-muted">{frm.tran_start_date ? moment(frm.tran_start_date).format('DD/MM/YYYY') : ""}</span>
                      </div>

                      {/* Transaction Status */}
                      <div className="col-md-2 text-center">
                        <span
                          className={`badge ${frm.trans_status === "Failed" || frm.trans_status === "Rejected"
                              ? "bg-danger"
                              : frm.trans_status === "Processing"
                                ? "bg-info"
                                : frm.trans_status === "Awaiting Auth"
                                  ? "bg-warning text-dark"
                                  : "bg-secondary"
                            }`}
                        >
                          {frm.trans_status}
                        </span>
                      </div>

                      {/* Response + Regenerate Btn */}
                      <div className="col-md-4 d-flex justify-content-between align-items-center gap-2">
                        <span>{frm.bse_response}
                          

                         
                        </span>
                         <div>
                            {showRegenerate && (
                            <span  className="fw-bold " style={{cursor:'pointer'}} onClick={() => regenerateAuth(frm.id)}>
                              <TfiReload color="red" size={20} />
                            </span>
                          )}
                          </div>
                      </div>
                    </div>

                    {/* Regenerate Button */}

                  </div>
                );
              })}
          </div>
        ) : (
          <Alert variant="warning" className="text-center fw-bold">
            No Form created
          </Alert>
        )}

      </Modal.Body>
    </Modal>
  );
};
